<template>
  <Modal v-model="innerVisible" :title="modalTitle" :width="1000" :mask-closable="false" class-name="rma-create-modal-wrap">
    <div class="rma-create-modal-body">
      <Spin v-if="editLoading" fix />
      <Form ref="createForm" :model="createForm" :rules="formRules" :label-width="0" class="rma-form-sheet" @submit.native.prevent>

        <div class="rma-form-block">
          <div class="rma-form-row4">
            <div class="rma-cell rma-cell-quarter">
              <span class="rma-lbl">记录编号</span>
              <FormItem prop="recordNumber" class="rma-form-item-block">
                <Input v-model="createForm.recordNumber" disabled clearable placeholder="默认生成" />
              </FormItem>
            </div>
            <div class="rma-cell rma-cell-quarter">
              <span class="rma-lbl">表单编号</span>
              <FormItem prop="formNumber" class="rma-form-item-block">
                <Input v-model="createForm.formNumber" disabled clearable placeholder="默认生成" />
              </FormItem>
            </div>
            <div class="rma-cell rma-cell-quarter">
              <span class="rma-lbl rma-req">事业部</span>
              <FormItem prop="causeDepartment" class="rma-form-item-block">
                <RadioGroup v-model="createForm.causeDepartment" @on-change="onCauseDepartmentChange">
                  <Radio v-for="o in (initOptions.causeDepartments || [])" :key="o.value" :label="o.value" :disabled="isFixedDepartment" class="rma-radio-yl">
                    {{ o.text }}
                  </Radio>
                </RadioGroup>
              </FormItem>
            </div>
            <div class="rma-cell rma-cell-quarter">
              <span class="rma-lbl rma-req">客户名称</span>
              <FormItem prop="customerName" class="rma-form-item-block">
                <Select
                  v-model="createForm.customerName"
                  filterable
                  clearable
                  :placeholder="customerNamePlaceholder"
                  :disabled="!customerSelectEnabled"
                  :loading="customerListLoading"
                  transfer
                  style="width: 100%"
                >
                  <Option v-for="c in customerSelectOptions" :key="customerOptKey(c)" :value="c.value">{{ c.label }}</Option>
                </Select>
              </FormItem>
            </div>

          </div>
        </div>

        <div class="rma-form-block">
          <div class="rma-form-label-row5">
            <div class="rma-td th"><span class="rma-req">物料名称</span></div>
            <div class="rma-td th">规格/型号</div>
            <div class="rma-td th"><span class="rma-req">图号/客户物料编码</span></div>
            <div class="rma-td th"><span class="rma-req">金蝶代码</span></div>
            <div class="rma-td th">报告部门</div>
          </div>
          <div class="rma-form-input-row5">
            <div class="rma-td">
              <FormItem prop="materialName" class="rma-nomargin">
                <Input v-model="createForm.materialName" placeholder="请输入" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="specificationModel" class="rma-nomargin">
                <Input v-model="createForm.specificationModel" placeholder="请输入" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="drawingOrCustomerMaterialCode" class="rma-nomargin">
                <Input v-model="createForm.drawingOrCustomerMaterialCode" placeholder="请输入" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="kingdeeCode" class="rma-nomargin">
                <Input v-model="createForm.kingdeeCode" placeholder="请输入" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="reportingDepartment" class="rma-nomargin">
                <Input v-model="createForm.reportingDepartment" placeholder="请输入" />
              </FormItem>
            </div>
          </div>
        </div>

        <div class="rma-form-block">
          <div class="rma-form-label-row5">
            <div class="rma-td th"><span class="rma-req">发生时间</span></div>
            <div class="rma-td th"><span class="rma-req">责任单位/部门</span></div>
            <div class="rma-td th"><span class="rma-req">责任人</span></div>
            <div class="rma-td th"><span class="rma-req">批次数量</span></div>
            <div class="rma-td th"><span class="rma-req">不合格数量</span></div>
          </div>
          <div class="rma-form-input-row5">
            <div class="rma-td">
              <FormItem prop="occurrenceTime" class="rma-nomargin">
                <DatePicker :value="createForm.occurrenceTime" type="datetime" style="width: 100%" format="yyyy-MM-dd HH:mm" placeholder="默认当前，可选日期时间" @on-change="onOccurrenceTimeChange" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="responsibleUnitOrDept" class="rma-nomargin">
                <Input v-model="createForm.responsibleUnitOrDept" placeholder="请输入" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="responsiblePerson" class="rma-nomargin">
                <Input v-model="createForm.responsiblePerson" placeholder="请输入" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="batchQuantity" class="rma-nomargin">
                <InputNumber v-model="createForm.batchQuantity" :min="0" style="width: 100%" placeholder="请输入" @on-change="onBatchNonConformingChange" />
              </FormItem>
            </div>
            <div class="rma-td">
              <FormItem prop="nonConformingQuantity" class="rma-nomargin">
                <InputNumber v-model="createForm.nonConformingQuantity" :min="0" style="width: 100%" placeholder="请输入" @on-change="onBatchNonConformingChange" />
              </FormItem>
            </div>
          </div>
        </div>

        <div class="rma-form-block rma-fbmain">
          <div class="rma-fbmain-hd">
            <span class="rma-lbl rma-req">不合格情况描述</span> <span>及图片</span>
          </div>
          <div v-for="(line, idx) in createFeedBackLines" :key="line._key" :class="['rma-fbline', { 'rma-fbline-extra': idx > 0 }]">
            <div v-if="idx > 0" class="rma-fbline-extra-bar">
              <span>问题 {{ idx + 1 }}</span>
              <Button type="error" size="small" @click="removeFeedBackLine(idx)">删除</Button>
            </div>
            <FormItem v-if="idx === 0" prop="firstProblem" class="rma-fbmain-desc">
              <Input v-model="createForm.firstProblem" type="textarea" :rows="4" placeholder="请填写不合格情况描述" @on-blur="syncFirstLineFromForm" />
            </FormItem>
            <div v-else class="rma-fbmain-desc rma-fbext-wrap">
              <Input v-model="line.problemDescription" type="textarea" :rows="3" placeholder="该问题不合格情况描述" />
            </div>
            <div class="rma-uploads">
              <div v-for="(pic, pidx) in line._pics" :key="(pic.fileGuids || 'p') + '-' + pidx" class="demo-upload-list rma-thumb">
                <img :src="linePicSrc(pic)" alt="" @click="openLinePicPreview(pic)" />
                <div class="rma-thumb-del-hit" title="删除" @click.stop="removeLinePic(line, pidx)">
                  <span class="rma-thumb-del-icon" aria-hidden="true">
                    <Icon type="md-close" :size="16" />
                  </span>
                </div>
              </div>
              <Upload :key="line._key + '-up'" class="rma-pic-uploader" :show-upload-list="false" :action="fileUploadAction" accept="image/*" :on-success="(r, f) => onLinePicSuccess(r, f, line)" :before-upload="flieLineUpload"
                :on-error="onLinePicUploadError" :on-format-error="onFormatError">
                <div class="rma-pic-add" title="选择本地图片">
                  <Icon type="md-add" :size="28" class="rma-pic-add-ico" />
                  <span class="rma-pic-add-t">上传</span>
                  <span class="rma-pic-add-hint">JPG/PNG 等</span>
                </div>
              </Upload>
            </div>
          </div>
          <Button type="dashed" long icon="md-add" class="margin-top-10" @click="addFeedBackLine">继续添加问题</Button>
        </div>

        <div v-if="editId && showOnSiteConfirm && wfBlockVisible('onSite')" class="rma-form-block rma-wf-create">
          <div class="rma-fbmain-hd">
            <span class="rma-lbl rma-req">现场确认状态</span>
          </div>
          <div class="rma-form-row2">
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl rma-req">数量</span>
              <InputNumber v-model="createForm.onSiteConfirmQuantity" :min="0" style="width: 100%" placeholder="请输入" />
            </div>
          </div>
          <div class="rma-wf-file-hd"><span class="rma-lbl rma-req">材料附件</span></div>
          <div class="rma-uploads margin-top-10">
            <div v-for="(pic, pidx) in onSiteConfirmPics" :key="(pic.fileGuids || 'os') + '-' + pidx" class="demo-upload-list rma-thumb">
              <img :src="linePicSrc(pic)" alt="" @click="openLinePicPreview(pic)" />
              <div class="rma-thumb-del-hit" title="删除" @click.stop="removeWorkflowPic('onSite', pidx)">
                <span class="rma-thumb-del-icon" aria-hidden="true">
                  <Icon type="md-close" :size="16" />
                </span>
              </div>
            </div>
            <Upload :key="onSiteConfirmUploadGuid + '-onSite-up'" class="rma-pic-uploader" :show-upload-list="false" :action="onSiteConfirmUploadAction" accept="image/*" :on-success="(r, f) => onWorkflowPicSuccess('onSite', r, f)"
              :before-upload="beforeOnSiteConfirmUpload" :on-error="onLinePicUploadError" :on-format-error="onFormatError">
              <div class="rma-pic-add" title="上传材料附件">
                <Icon type="md-add" :size="28" class="rma-pic-add-ico" />
                <span class="rma-pic-add-t">上传</span>
                <span class="rma-pic-add-hint">必填</span>
              </div>
            </Upload>
          </div>
        </div>

        <div v-if="editId && showWarehouseInbound && wfBlockVisible('warehouse')" class="rma-form-block rma-wf-create">
          <div class="rma-fbmain-hd">
            <span class="rma-lbl rma-req">客退品仓入库</span>
          </div>
          <div class="rma-form-row2">
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl rma-req">数量</span>
              <InputNumber v-model="createForm.warehouseInboundQuantity" :min="0" style="width: 100%" placeholder="请输入" />
            </div>
          </div>
          <div class="rma-wf-file-hd"><span class="rma-lbl rma-req">入库附件</span></div>
          <div class="rma-uploads margin-top-10">
            <div v-for="(pic, pidx) in warehouseInboundPics" :key="(pic.fileGuids || 'wi') + '-' + pidx" class="demo-upload-list rma-thumb">
              <img :src="linePicSrc(pic)" alt="" @click="openLinePicPreview(pic)" />
              <div class="rma-thumb-del-hit" title="删除" @click.stop="removeWorkflowPic('warehouse', pidx)">
                <span class="rma-thumb-del-icon" aria-hidden="true">
                  <Icon type="md-close" :size="16" />
                </span>
              </div>
            </div>
            <Upload :key="warehouseInUploadGuid + '-wi-up'" class="rma-pic-uploader" :show-upload-list="false" :action="warehouseInUploadAction" accept="image/*" :on-success="(r, f) => onWorkflowPicSuccess('warehouse', r, f)"
              :before-upload="beforeWarehouseInUpload" :on-error="onLinePicUploadError" :on-format-error="onFormatError">
              <div class="rma-pic-add" title="上传入库附件">
                <Icon type="md-add" :size="28" class="rma-pic-add-ico" />
                <span class="rma-pic-add-t">上传</span>
                <span class="rma-pic-add-hint">必填</span>
              </div>
            </Upload>
          </div>
        </div>

        <div v-if="editId && showReplenishment && wfBlockVisible('replenishment')" class="rma-form-block rma-wf-create">
          <div class="rma-fbmain-hd">
            <span class="rma-lbl rma-req">补货处理</span>
          </div>
          <div class="rma-form-row2">
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl rma-req">补货数量</span>
              <InputNumber v-model="createForm.replenishmentQuantity" :min="0" style="width: 100%" placeholder="请输入" />
            </div>
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl rma-req">完成日期</span>
              <DatePicker :value="createForm.replenishmentCompleteDate" type="date" style="width: 100%" format="yyyy-MM-dd" placeholder="请选择" transfer @on-change="onReplenishmentCompleteDateChange" />
            </div>
          </div>
        </div>

        <div v-if="editId && showReturnProcess && wfBlockVisible('return')" class="rma-form-block rma-wf-create">
          <div class="rma-fbmain-hd">
            <span class="rma-lbl rma-req">退货处理</span>
          </div>
          <div class="rma-form-row2">
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl rma-req">退货数量</span>
              <InputNumber v-model="createForm.returnProcessQuantity" :min="0" style="width: 100%" placeholder="请输入" />
            </div>
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl rma-req">完成日期</span>
              <DatePicker :value="createForm.returnProcessCompleteDate" type="date" style="width: 100%" format="yyyy-MM-dd" placeholder="请选择" transfer @on-change="onReturnProcessCompleteDateChange" />
            </div>
          </div>
        </div>

        <!-- <div class="rma-form-block rma-fill-meta">
          <div class="rma-form-row2">
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl">销售填表人</span>
              <FormItem prop="salesSubmitterName" class="rma-form-item-block">
                <Input v-model="createForm.salesSubmitterName" />
              </FormItem>
            </div>
            <div class="rma-cell rma-cell-half">
              <span class="rma-lbl">销售填表时间</span>
              <FormItem prop="salesFillTime" class="rma-form-item-block">
                <DatePicker v-model="createForm.salesFillTime" type="datetime" style="width: 100%" format="yyyy-MM-dd HH:mm" />
              </FormItem>
            </div>
          </div>
        </div> -->
      </Form>
    </div>
    <div slot="footer">
      <Button @click="close">取消</Button>
      <Button type="primary" :loading="submitting" @click="submitCreate">{{ submitButtonText }}</Button>
    </div>
  </Modal>
</template>

<script>
const API = '/api/services/app/RMA_Order'

import { rmaSegmentEditable } from './rmaWorkflowSegmentUtils'

function pickFirstNum(obj, keys) {
  if (!obj) return null
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (!Object.prototype.hasOwnProperty.call(obj, k)) continue
    const v = obj[k]
    if (v === null || v === undefined || v === '') continue
    const n = Number(v)
    if (!Number.isNaN(n)) return n
  }
  return null
}

function pickFirstStr(obj, keys) {
  if (!obj) return ''
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (!Object.prototype.hasOwnProperty.call(obj, k)) continue
    const v = obj[k]
    if (v != null && String(v).trim() !== '') return String(v).trim()
  }
  return ''
}

function pickFirstRaw(obj, keys) {
  if (!obj) return null
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (!Object.prototype.hasOwnProperty.call(obj, k)) continue
    const v = obj[k]
    if (v != null && v !== '') return v
  }
  return null
}

function mapPictureFilesToPics(arr) {
  if (!Array.isArray(arr)) return []
  return arr
    .map((p) => {
      const g = p.fileGuids || p.guid
      const u = p.url != null && p.url !== '' ? p.url : p.imageUrl || ''
      const fn = p.fileName != null ? p.fileName : p.FileName
      return g ? { fileGuids: g, url: u || '', fileName: fn || '' } : null
    })
    .filter(Boolean)
}

const emptyCreateForm = () => ({
  recordNumber: '',
  formNumber: '',
  causeDepartment: null,
  customerName: '',
  materialName: '',
  specificationModel: '',
  drawingOrCustomerMaterialCode: '',
  kingdeeCode: '',
  reportingDepartment: '',
  occurrenceTime: null,
  responsibleUnitOrDept: '',
  responsiblePerson: '',
  batchQuantity: null,
  nonConformingQuantity: null,
  salesSubmitterUserId: null,
  salesSubmitterName: '',
  salesFillTime: null,
  /** 与首行 feedBack 描述同步，用于 Form 校验 */
  firstProblem: '',
  /** 四项流程（不写入主单 mainKeys，提交见 WorkflowReturnProcessUpdate） */
  onSiteConfirmQuantity: null,
  warehouseInboundQuantity: null,
  replenishmentQuantity: null,
  replenishmentCompleteDate: null,
  returnProcessQuantity: null,
  returnProcessCompleteDate: null,
})

function newKey() {
  return 'k' + Date.now() + Math.random().toString(16).slice(2)
}

/** 去空白后非空，用于文本必填 */
function rmaTrimRequired(msg) {
  return (rule, value, callback) => {
    if (value == null || String(value).trim() === '') {
      callback(new Error(msg))
    } else {
      callback()
    }
  }
}

/** 数字必填，0 有效 */
function rmaCountRequired(msg) {
  return (rule, value, callback) => {
    if (value === null || value === undefined || value === '') {
      callback(new Error(msg))
    } else if (typeof value !== 'number' || Number.isNaN(value)) {
      callback(new Error(msg))
    } else {
      callback()
    }
  }
}

function rmaOccurrenceRequired(rule, value, callback) {
  if (value == null || String(value).trim() === '') {
    callback(new Error('请选择发生时间'))
  } else {
    callback()
  }
}

/** 均已填有效数字时校验：批次数量 >= 不合格数量 */
function batchGteNonConforming(component, callback) {
  const f = component.createForm
  const batch = f.batchQuantity
  const nc = f.nonConformingQuantity
  if (
    batch === null ||
    batch === undefined ||
    batch === '' ||
    typeof batch !== 'number' ||
    Number.isNaN(batch)
  ) {
    callback()
    return
  }
  if (nc === null || nc === undefined || nc === '' || typeof nc !== 'number' || Number.isNaN(nc)) {
    callback()
    return
  }
  if (batch < nc) {
    callback(new Error('批次数量须大于或等于不合格数量'))
    return
  }
  callback()
}

export default {
  name: 'RMAOrderCreateForm',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /** 有值时为编辑模式，提交走 UpdateOrder */
    editId: {
      type: Number,
      default: null,
    },
    initOptions: {
      type: Object,
      default: () => ({}),
    },
    /**
     * 从列表/详情进入时锁定只展示某一子流程块：onSite | warehouse | replenishment | return；
     * 空则展示后端 isShow 为真的全部块（与「编辑」一致）。
     */
    workflowFocus: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      createForm: emptyCreateForm(),
      isFixedDepartment: false,
      createFeedBackLines: [],
      submitting: false,
      editLoading: false,
      showOnSiteConfirm: false,
      showWarehouseInbound: false,
      showReplenishment: false,
      showReturnProcess: false,
      onSiteConfirmPics: [],
      warehouseInboundPics: [],
      onSiteConfirmUploadGuid: '',
      warehouseInUploadGuid: '',
      /** GetMgrInitData(departmentType=事业部) 返回的 customerList 映射 */
      customerSelectOptions: [],
      customerListLoading: false,
    }
  },
  computed: {
    formRules() {
      return {
        causeDepartment: [
          { required: true, type: 'number', message: '请选择事业部', trigger: 'change' },
        ],
        customerName: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
          { validator: rmaTrimRequired('请选择客户名称'), trigger: 'change' },
        ],
        materialName: [{ validator: rmaTrimRequired('请填写物料名称'), trigger: 'blur' }],
        drawingOrCustomerMaterialCode: [
          { validator: rmaTrimRequired('请填写图号/客户物料编码'), trigger: 'blur' },
        ],
        kingdeeCode: [{ validator: rmaTrimRequired('请填写金蝶代码'), trigger: 'blur' }],
        occurrenceTime: [{ validator: rmaOccurrenceRequired, trigger: 'change' }],
        responsibleUnitOrDept: [
          { validator: rmaTrimRequired('请填写责任单位/部门'), trigger: 'blur' },
        ],
        responsiblePerson: [{ validator: rmaTrimRequired('请填写责任人'), trigger: 'blur' }],
        batchQuantity: [
          { validator: rmaCountRequired('请填写批次数量'), trigger: 'change' },
          {
            validator: (rule, value, callback) => batchGteNonConforming(this, callback),
            trigger: 'change',
          },
        ],
        nonConformingQuantity: [
          { validator: rmaCountRequired('请填写不合格数量'), trigger: 'change' },
          {
            validator: (rule, value, callback) => batchGteNonConforming(this, callback),
            trigger: 'change',
          },
        ],
        firstProblem: [{ required: true, message: '请填写不合格情况描述', trigger: 'blur' }],
      }
    },
    baseUrl() {
      return this.$constDefinition.baseUrl
    },
    /** 与 attendance/dateImport.vue 一致：通用文件上传 */
    fileUploadAction() {
      const base = typeof abp !== 'undefined' && abp && abp.url ? abp.url : this.baseUrl
      return `${base}/file/Upload`
    },
    /** 现场确认材料附件：专用上传地址 */
    onSiteConfirmUploadAction() {
      const base = typeof abp !== 'undefined' && abp && abp.url ? abp.url : this.baseUrl
      return `${base}/file/UploadByRMA_OrderOnsiteConfirm?guid=${this.onSiteConfirmUploadGuid}`
    },
    /** 客退品仓入库附件 */
    warehouseInUploadAction() {
      const base = typeof abp !== 'undefined' && abp && abp.url ? abp.url : this.baseUrl
      return `${base}/file/UploadByRMA_OrderWarehouseIn?guid=${this.warehouseInUploadGuid}`
    },
    innerVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    modalTitle() {
      if (this.editId != null) {
        if (this.workflowFocus) return '处理不良品处理单'
        return '编辑不良品处理单'
      }
      return '不良品处理单'
    },
    submitButtonText() {
      return this.editId != null ? '保存' : '提交'
    },
    /** 已选事业部后才拉取 / 可选客户 */
    customerSelectEnabled() {
      const d = this.createForm.causeDepartment
      return d !== null && d !== undefined && d !== ''
    },
    customerNamePlaceholder() {
      return this.customerSelectEnabled ? '请选择客户' : '请先选择事业部'
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.editLoading = false
        this.customerSelectOptions = []
        this.$emit('update:editId', null)
        return
      }
      if (this.editId != null) this.loadEditOrder()
      else this.resetCreate()
    },
  },
  methods: {
    /** 子流程块是否渲染：无 focus 时展示全部已放开块；有 focus 时仅展示对应一块（仍须 isShow 为真） */
    wfBlockVisible(section) {
      if (!this.workflowFocus) return true
      return this.workflowFocus === section
    },
    /** 校验与提交是否包含该段：后端 isShow 且本次入口未锁定或锁定到本段 */
    wfIncluded(section) {
      let backend = false
      if (section === 'onSite') backend = this.showOnSiteConfirm
      else if (section === 'warehouse') backend = this.showWarehouseInbound
      else if (section === 'replenishment') backend = this.showReplenishment
      else if (section === 'return') backend = this.showReturnProcess
      if (!backend) return false
      if (!this.workflowFocus) return true
      return this.workflowFocus === section
    },
    checkWorkflowFocusAllowed() {
      const f = this.workflowFocus
      if (!f || !this.editId) return
      const ok =
        (f === 'onSite' && this.showOnSiteConfirm) ||
        (f === 'warehouse' && this.showWarehouseInbound) ||
        (f === 'replenishment' && this.showReplenishment) ||
        (f === 'return' && this.showReturnProcess)
      if (!ok) {
        this.$Message.warning('当前单据该环节不可办理')
        this.close()
      }
    },
    syncFirstLineFromForm() {
      if (this.createFeedBackLines[0]) {
        this.createFeedBackLines[0].problemDescription = this.createForm.firstProblem
      }
    },
    onBatchNonConformingChange() {
      this.$nextTick(() => {
        const f = this.$refs.createForm
        if (!f) return
        f.validateField('batchQuantity')
        f.validateField('nonConformingQuantity')
      })
    },
    close() {
      this.$emit('update:editId', null)
      this.$emit('input', false)
    },
    parseAbpData(httpBody) {
      if (httpBody == null) return null
      if (Object.prototype.hasOwnProperty.call(httpBody, 'result')) return httpBody.result
      return httpBody
    },
    /** 下拉 option 的稳定 key（value 优先，否则 label） */
    customerOptKey(c) {
      if (!c) return ''
      const v = c.value != null ? String(c.value) : ''
      const l = c.label != null ? String(c.label) : ''
      return v !== '' ? v : l !== '' ? l : '_' + Math.random()
    },
    /** 后端 customerList / 下拉项映射为 Select 所需的 value/label（提交仍写入 customerName 字符串） */
    normalizeCustomerOptions(list) {
      if (!Array.isArray(list)) return []
      const out = []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (item == null) continue
        if (typeof item === 'string') {
          const s = item.trim()
          if (s) out.push({ value: s, label: s })
          continue
        }
        const text = pickFirstStr(item, ['text', 'Text', 'customerName', 'CustomerName', 'name', 'Name', 'label', 'Label', 'companyName'])
        const altVal = pickFirstStr(item, ['value', 'Value', 'id', 'customerId'])
        const value = text || altVal || ''
        if (!value) continue
        const label = text || value
        out.push({ value, label })
      }
      return out
    },
    /** 编辑或历史数据中客户不在当前事业部列表时也允许展示、提交 */
    ensureCustomerInOptions(name) {
      const n = name != null ? String(name).trim() : ''
      if (!n) return
      if (this.customerSelectOptions.some((o) => o.value === n || o.label === n)) return
      this.customerSelectOptions = [{ value: n, label: n }, ...this.customerSelectOptions]
    },
    async refreshCustomerListForDept(departmentType) {
      const d = departmentType
      const valid = d !== null && d !== undefined && d !== ''
      if (!valid) {
        this.customerSelectOptions = []
        return
      }
      this.customerListLoading = true
      try {
        const { data } = await this.$Ajax.get(`${API}/GetMgrInitData`, {
          params: { departmentType: d },
        })
        const r = this.parseAbpData(data) || {}
        const raw = r.customerList || r.CustomerList || []
        this.customerSelectOptions = this.normalizeCustomerOptions(raw)
        this.ensureCustomerInOptions(this.createForm.customerName)
      } catch (e) {
        this.$Message.error('获取客户列表失败')
        this.customerSelectOptions = []
      } finally {
        this.customerListLoading = false
      }
    },
    onCauseDepartmentChange() {
      if (!this.innerVisible) return
      const ed = this.editId != null
      const skipClear = ed || this.editLoading
      if (!skipClear) {
        this.createForm.customerName = ''
      }
      this.refreshCustomerListForDept(this.createForm.causeDepartment)
    },
    async loadEditOrder() {
      if (this.editId == null) return
      this.editLoading = true
      try {
        const { data } = await this.$Ajax.get(`${API}/GetOrderDetail`, {
          params: { id: this.editId },
        })
        const order = this.parseAbpData(data)
        if (!order) {
          this.$Message.error('加载单据失败')
          this.close()
          return
        }
        this.mapDetailToCreateForm(order)
        await this.refreshCustomerListForDept(this.createForm.causeDepartment)
        this.$nextTick(() => {
          this.checkWorkflowFocusAllowed()
          this.clearFormValidation()
          this.$nextTick(() => this.clearFormValidation())
        })
      } catch (e) {
        this.$Message.error('加载单据失败')
        this.close()
      } finally {
        this.editLoading = false
      }
    },
    mapDetailToCreateForm(order) {
      this.isFixedDepartment = false
      const occ = order.occurrenceTime
      let occurrenceTimeStr = this.$moment().format('YYYY-MM-DD HH:mm')
      if (occ != null && occ !== '') {
        occurrenceTimeStr = this.$moment(occ).format('YYYY-MM-DD HH:mm')
      }
      this.createForm = {
        ...emptyCreateForm(),
        recordNumber: order.recordNumber || '',
        formNumber: order.formNumber || '',
        causeDepartment: order.causeDepartment != null ? order.causeDepartment : null,
        customerName: order.customerName || '',
        materialName: order.materialName || '',
        specificationModel: order.specificationModel || '',
        drawingOrCustomerMaterialCode: order.drawingOrCustomerMaterialCode || '',
        kingdeeCode: order.kingdeeCode || '',
        reportingDepartment: order.reportingDepartment || '',
        occurrenceTime: occurrenceTimeStr,
        responsibleUnitOrDept: order.responsibleUnitOrDept || '',
        responsiblePerson: order.responsiblePerson || '',
        batchQuantity: order.batchQuantity != null ? Number(order.batchQuantity) : null,
        nonConformingQuantity:
          order.nonConformingQuantity != null ? Number(order.nonConformingQuantity) : null,
        salesSubmitterUserId:
          order.salesSubmitterUserId != null ? order.salesSubmitterUserId : null,
        salesSubmitterName: order.salesSubmitterName || '',
        salesFillTime: order.salesFillTime || null,
        firstProblem: '',
        onSiteConfirmQuantity: pickFirstNum(order, [
          'onsiteConfirmQuantity',
          'OnsiteConfirmQuantity',
          'onSiteConfirmationQuantity',
          'OnSiteConfirmQuantity',
        ]),
        warehouseInboundQuantity: pickFirstNum(order, [
          'returnWarehouseInQuantity',
          'ReturnWarehouseInQuantity',
          'warehouseInboundQuantity',
          'customerReturnWarehouseInboundQuantity',
          'WarehouseInboundQuantity',
        ]),
        replenishmentQuantity: pickFirstNum(order, [
          'replenishmentQuantity',
          'replenishmentProcessQuantity',
          'ReplenishmentQuantity',
        ]),
        returnProcessQuantity: pickFirstNum(order, [
          'returnQuantity',
          'ReturnQuantity',
          'returnProcessQuantity',
          'returnHandlingQuantity',
          'ReturnProcessQuantity',
        ]),
      }
      this.createForm.replenishmentCompleteDate = this.formatDetailDateYmd(
        pickFirstRaw(order, [
          'replenishmentCompleteDate',
          'replenishmentProcessCompleteDate',
          'ReplenishmentCompleteDate',
          'replenishmentCompletedTime',
          'ReplenishmentCompletedTime',
        ])
      )
      this.createForm.returnProcessCompleteDate = this.formatDetailDateYmd(
        pickFirstRaw(order, [
          'returnProcessCompleteDate',
          'returnHandlingCompleteDate',
          'ReturnProcessCompleteDate',
          'returnCompletedTime',
          'ReturnCompletedTime',
        ])
      )
      this.showOnSiteConfirm = !!(this.editId != null && rmaSegmentEditable(order, 'onSite'))
      this.showWarehouseInbound = !!(this.editId != null && rmaSegmentEditable(order, 'warehouse'))
      this.showReplenishment = !!(this.editId != null && rmaSegmentEditable(order, 'replenishment'))
      this.showReturnProcess = !!(this.editId != null && rmaSegmentEditable(order, 'return'))
      this.onSiteConfirmPics = mapPictureFilesToPics(
        order.onsiteConfirmMaterialFiles ||
          order.OnsiteConfirmMaterialFiles ||
          order.onSiteConfirmPictureFiles ||
          order.onSiteConfirmationPictureFiles ||
          order.onSiteConfirmPictureFileList ||
          []
      )
      this.warehouseInboundPics = mapPictureFilesToPics(
        order.returnWarehouseInFiles ||
          order.ReturnWarehouseInFiles ||
          order.warehouseInboundPictureFiles ||
          order.customerReturnWarehouseInboundPictureFiles ||
          order.warehouseInboundPictureFileList ||
          []
      )
      this.onSiteConfirmUploadGuid = this.createGuid()
      this.warehouseInUploadGuid = this.createGuid()
      const lines = order.feedBacks || order.feedBackLines || []
      this.createFeedBackLines = lines.map((fb, i) => ({
        _key: newKey(),
        problemDescription: fb.problemDescription || '',
        sortIndex: i,
        _pics: (fb.pictureFiles || [])
          .map((p) => {
            const g = p.fileGuids || p.guid || p.id
            const u = p.url != null && p.url !== '' ? p.url : p.imageUrl || ''
            return g ? { fileGuids: g, url: u || '' } : null
          })
          .filter(Boolean),
      }))
      if (!this.createFeedBackLines.length) {
        this.addFeedBackLine()
      }
      if (this.createFeedBackLines[0]) {
        this.createForm.firstProblem = this.createFeedBackLines[0].problemDescription || ''
      }
    },
    onOccurrenceTimeChange(val) {
      if (val == null || val === '') {
        this.createForm.occurrenceTime = null
        return
      }
      this.createForm.occurrenceTime = this.$moment(val).format('YYYY-MM-DD HH:mm')
    },
    formatDetailDateYmd(raw) {
      if (raw == null || raw === '') return null
      const d = this.$moment(raw)
      if (!d.isValid()) return null
      return d.format('YYYY-MM-DD')
    },
    onReplenishmentCompleteDateChange(val) {
      if (val == null || val === '') {
        this.createForm.replenishmentCompleteDate = null
        return
      }
      this.createForm.replenishmentCompleteDate = this.$moment(val).format('YYYY-MM-DD')
    },
    onReturnProcessCompleteDateChange(val) {
      if (val == null || val === '') {
        this.createForm.returnProcessCompleteDate = null
        return
      }
      this.createForm.returnProcessCompleteDate = this.$moment(val).format('YYYY-MM-DD')
    },
    resetCreate() {
      this.createForm = emptyCreateForm()

      const path = (this.$route.path || '').toLowerCase()
      if (path.endsWith('rd')) {
        this.createForm.causeDepartment = 3
        this.isFixedDepartment = true
      } else if (path.endsWith('oem') || path.endsWith('ome')) {
        this.createForm.causeDepartment = 2
        this.isFixedDepartment = true
      } else {
        this.isFixedDepartment = false
      }

      this.createForm.occurrenceTime = this.$moment().format('YYYY-MM-DD HH:mm')
      this.createFeedBackLines = []
      const u = this.$store.state.session && this.$store.state.session.user
      if (u) {
        this.createForm.salesSubmitterUserId = u.id != null ? u.id : null
        this.createForm.salesSubmitterName =
          (u.name || u.surname || '') + (u.userName ? ' (' + u.userName + ')' : '')
        this.createForm.salesFillTime = this.$moment().format('YYYY-MM-DD HH:mm')
      }
      this.addFeedBackLine()
      this.createForm.firstProblem = ''
      if (this.createFeedBackLines[0]) {
        this.createFeedBackLines[0].problemDescription = ''
      }
      this.showOnSiteConfirm = false
      this.showWarehouseInbound = false
      this.showReplenishment = false
      this.showReturnProcess = false
      this.onSiteConfirmPics = []
      this.warehouseInboundPics = []
      this.onSiteConfirmUploadGuid = this.createGuid()
      this.warehouseInUploadGuid = this.createGuid()
      this.customerSelectOptions = []
      /** 事业部由路由预设时顺带拉客户列表（Radio 未触发交互 @on-change 的场景） */
      this.$nextTick(() => this.refreshCustomerListForDept(this.createForm.causeDepartment))
      /** 不调用 Form.resetFields()，否则会写回各 FormItem 的 initialValue，与上面新建数据冲突；仅清校验态 */
      this.$nextTick(() => {
        this.clearFormValidation()
        this.$nextTick(() => this.clearFormValidation())
      })
    },
    /** 清除 iView 表单项上次的错误提示与红框（与 model 重填配合，每次重新打开弹窗时调用） */
    clearFormValidation() {
      const form = this.$refs.createForm
      if (!form || !form.fields) return
      form.fields.forEach((field) => {
        field.validateState = ''
        field.validateMessage = ''
      })
    },
    bindFirstLineToForm() {
      this.$nextTick(() => {
        if (this.createFeedBackLines[0] && this.$refs.createForm) {
          this.createForm = {
            ...this.createForm,
            firstProblem: this.createFeedBackLines[0].problemDescription,
          }
        }
      })
    },
    addFeedBackLine() {
      this.createFeedBackLines.push({
        _key: newKey(),
        problemDescription: '',
        sortIndex: this.createFeedBackLines.length,
        _pics: [],
      })
    },
    removeFeedBackLine(i) {
      if (this.createFeedBackLines.length <= 1) {
        this.$Message.warning('至少保留一条问题')
        return
      }
      this.createFeedBackLines.splice(i, 1)
    },
    /** 与 dateImport.vue 的 flieUpload 一致（问题支持多图，仅放行） */
    flieLineUpload() {
      return true
    },
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    createGuid() {
      return `${this.S4()}${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}-${this.S4()}${this.S4()}${this.S4()}`
    },
    beforeOnSiteConfirmUpload() {
      this.onSiteConfirmUploadGuid = this.createGuid()
      return true
    },
    beforeWarehouseInUpload() {
      this.warehouseInUploadGuid = this.createGuid()
      return true
    },
    onLinePicSuccess(res, file, line) {
      const r0 = res && res.result !== undefined ? res.result : res
      const g =
        (r0 && r0.guid) ||
        (res && res.result && res.result.guid) ||
        (res && res.guid) ||
        (res && res.data && res.data.result && res.data.result.guid)
      let u =
        (r0 && (r0.imageUrl != null && r0.imageUrl !== '' ? r0.imageUrl : r0.url)) ||
        (res && res.imageUrl) ||
        (res && res.data && res.data.result && (res.data.result.imageUrl || res.data.result.url))
      if (!u && file && file.response) {
        const fr = file.response.result !== undefined ? file.response.result : file.response
        u = (fr && (fr.imageUrl || fr.url)) || u
      }
      if (g) line._pics.push({ fileGuids: g, url: u || '' })
    },
    /** 缩略/预览用地址：兼容绝对 URL、/ 开头、及与 RMA 详情页一致的 url/imageUrl */
    linePicSrc(pic) {
      if (!pic) return ''
      const path =
        (pic.url != null && pic.url !== '' ? pic.url : '') ||
        (pic.imageUrl != null && pic.imageUrl !== '' ? pic.imageUrl : '') ||
        (pic.filePath != null && pic.filePath !== '' ? pic.filePath : '') ||
        (pic.guid ? `/files/previewThumbnail/${pic.guid}` : '') ||
        (pic.fileGuids ? `/files/previewThumbnail/${pic.fileGuids}` : '')
      if (!path) return ''
      const s = String(path).trim()
      if (
        /^https?:\/\//i.test(s) ||
        s.startsWith('//') ||
        s.startsWith('blob:') ||
        s.startsWith('data:')
      ) {
        return s
      }
      return this.baseUrl + (s.startsWith('/') ? s : `/${s}`)
    },
    openLinePicPreview(pic) {
      let href = this.linePicSrc(pic)
      if (!href) return
      if (href.indexOf('/previewThumbnail/') > -1) {
        href = href.replace('/previewThumbnail/', '/preview/')
      }
      window.open(href)
    },
    onLinePicUploadError() {
      this.$Message.error('上传失败')
    },
    onFormatError() {
      this.$Message.warning('文件格式不支持')
    },
    removeLinePic(line, pidx) {
      line._pics.splice(pidx, 1)
    },
    onWorkflowPicSuccess(bucket, res, file) {
      const pics = bucket === 'warehouse' ? this.warehouseInboundPics : this.onSiteConfirmPics
      const r0 = res && res.result !== undefined ? res.result : res
      const g =
        (r0 && r0.guid) ||
        (res && res.result && res.result.guid) ||
        (res && res.guid) ||
        (res && res.data && res.data.result && res.data.result.guid)
      let u =
        (r0 && (r0.imageUrl != null && r0.imageUrl !== '' ? r0.imageUrl : r0.url)) ||
        (res && res.imageUrl) ||
        (res && res.data && res.data.result && (res.data.result.imageUrl || res.data.result.url))
      if (!u && file && file.response) {
        const fr = file.response.result !== undefined ? file.response.result : file.response
        u = (fr && (fr.imageUrl || fr.url)) || u
      }
      const fileName = (file && file.name) || (file && file.filename) || undefined
      if (g) pics.push({ fileGuids: g, url: u || '', fileName })
    },
    removeWorkflowPic(bucket, pidx) {
      if (bucket === 'warehouse') this.warehouseInboundPics.splice(pidx, 1)
      else this.onSiteConfirmPics.splice(pidx, 1)
    },
    buildFeedBackLinesPayload() {
      return this.createFeedBackLines.map((x, i) => ({
        problemDescription: x.problemDescription,
        sortIndex: i,
        pictureFiles: (x._pics || []).map((p) => ({ fileGuids: p.fileGuids })),
      }))
    },
    /** 附件提交给 WorkflowReturnProcessUpdate */
    mapWorkflowFilesForApi(pics) {
      return (pics || []).map((p) => ({
        fileGuids: p.fileGuids || p.guid,
        fileName: (p.fileName && String(p.fileName).trim()) || undefined,
        url: p.url != null && p.url !== '' ? p.url : undefined,
      }))
    },
    dateYmdToIsoStart(ymd) {
      if (ymd == null || String(ymd).trim() === '') return undefined
      return this.$moment(ymd, 'YYYY-MM-DD').startOf('day').toISOString()
    },
    /**
     * WorkflowReturnProcessUpdate 单次提交体（多段流程同时开启则合并为一个对象）。
     */
    buildWorkflowPayload() {
      const id = this.editId
      if (!id) return null
      const f = this.createForm
      const body = { id }
      let has = false
      if (this.wfIncluded('onSite')) {
        has = true
        body.IsOnsiteConfirmed = true
        body.onsiteConfirmQuantity = f.onSiteConfirmQuantity
        body.onsiteConfirmMaterialFiles = this.mapWorkflowFilesForApi(this.onSiteConfirmPics)
      }
      if (this.wfIncluded('warehouse')) {
        has = true
        body.isReturnWarehouseIn = true
        body.returnWarehouseInQuantity = f.warehouseInboundQuantity
        body.returnWarehouseInFiles = this.mapWorkflowFilesForApi(this.warehouseInboundPics)
      }
      if (this.wfIncluded('replenishment')) {
        has = true
        body.isReplenishmentHandled = true
        body.replenishmentQuantity = f.replenishmentQuantity
        body.replenishmentCompletedTime = this.dateYmdToIsoStart(f.replenishmentCompleteDate)
      }
      if (this.wfIncluded('return')) {
        has = true
        body.isReturnHandled = true
        body.returnQuantity = f.returnProcessQuantity
        body.returnCompletedTime = this.dateYmdToIsoStart(f.returnProcessCompleteDate)
      }
      return has ? body : null
    },
    validateWorkflowSections() {
      const f = this.createForm
      if (!this.editId) return true
      if (this.wfIncluded('onSite')) {
        if (
          f.onSiteConfirmQuantity === null ||
          f.onSiteConfirmQuantity === undefined ||
          f.onSiteConfirmQuantity === ''
        ) {
          this.$Message.warning('请填写现场确认的数量')
          return false
        }
        if (typeof f.onSiteConfirmQuantity === 'number' && Number.isNaN(f.onSiteConfirmQuantity)) {
          this.$Message.warning('请填写现场确认的数量')
          return false
        }
        if (!this.onSiteConfirmPics.length) {
          this.$Message.warning('请上传至少一件现场确认材料附件')
          return false
        }
      }
      if (this.wfIncluded('warehouse')) {
        if (
          f.warehouseInboundQuantity === null ||
          f.warehouseInboundQuantity === undefined ||
          f.warehouseInboundQuantity === ''
        ) {
          this.$Message.warning('请填写客退品仓入库的数量')
          return false
        }
        if (
          typeof f.warehouseInboundQuantity === 'number' &&
          Number.isNaN(f.warehouseInboundQuantity)
        ) {
          this.$Message.warning('请填写客退品仓入库的数量')
          return false
        }
        if (!this.warehouseInboundPics.length) {
          this.$Message.warning('请上传至少一件客退品仓入库附件')
          return false
        }
      }
      if (this.wfIncluded('replenishment')) {
        if (
          f.replenishmentQuantity === null ||
          f.replenishmentQuantity === undefined ||
          f.replenishmentQuantity === ''
        ) {
          this.$Message.warning('请填写补货处理的补货数量')
          return false
        }
        if (typeof f.replenishmentQuantity === 'number' && Number.isNaN(f.replenishmentQuantity)) {
          this.$Message.warning('请填写补货处理的补货数量')
          return false
        }
        if (
          f.replenishmentCompleteDate == null ||
          String(f.replenishmentCompleteDate).trim() === ''
        ) {
          this.$Message.warning('请选择补货处理的完成日期')
          return false
        }
      }
      if (this.wfIncluded('return')) {
        if (
          f.returnProcessQuantity === null ||
          f.returnProcessQuantity === undefined ||
          f.returnProcessQuantity === ''
        ) {
          this.$Message.warning('请填写退货数量')
          return false
        }
        if (typeof f.returnProcessQuantity === 'number' && Number.isNaN(f.returnProcessQuantity)) {
          this.$Message.warning('请填写退货数量')
          return false
        }
        if (
          f.returnProcessCompleteDate == null ||
          String(f.returnProcessCompleteDate).trim() === ''
        ) {
          this.$Message.warning('请选择退货处理的完成日期')
          return false
        }
      }
      return true
    },
    /** 后端流程接口就绪后于此处接 $Ajax.post；当前不调真实接口 */
    async runSubmitWorkflowPlaceholder(payload) {
      if (!payload) return
      await this.$Ajax.post(`${API}/WorkflowReturnProcessUpdate`, payload)
    },
    pickPayload(obj, keys) {
      const o = {}
      keys.forEach((k) => {
        if (k === 'firstProblem') return
        const v = obj[k]
        if (v !== '' && v != null) o[k] = v
      })
      return o
    },
    async submitCreate() {
      this.syncFirstLineFromForm()
      const valid = await new Promise((resolve) => {
        this.$refs.createForm.validate((ok) => resolve(ok))
      })
      if (!valid) return

      if (!this.createFeedBackLines.length) {
        this.$Message.warning('请至少维护一条「不合格情况描述」问题')
        return
      }
      const needDesc = this.createFeedBackLines.some((l) => !l.problemDescription)
      if (needDesc) {
        this.$Message.warning('请填写每行不合格情况描述')
        return
      }
      if (!this.validateWorkflowSections()) return
      const mainKeys = [
        'recordNumber',
        'formNumber',
        'causeDepartment',
        'customerName',
        'materialName',
        'specificationModel',
        'drawingOrCustomerMaterialCode',
        'kingdeeCode',
        'reportingDepartment',
        'occurrenceTime',
        'responsibleUnitOrDept',
        'responsiblePerson',
        'batchQuantity',
        'nonConformingQuantity',
        'salesSubmitterUserId',
        'salesSubmitterName',
        'salesFillTime',
      ]
      this.submitting = true
      try {
        const main = this.pickPayload(this.createForm, mainKeys)
        main.feedBackLines = this.buildFeedBackLinesPayload()
        if (this.editId != null) {
          main.id = this.editId
          await this.$Ajax.post(`${API}/UpdateOrder`, main)
          this.$Message.success('保存成功')
        } else {
          await this.$Ajax.post(`${API}/CreateOrder`, main)
          this.$Message.success('创建成功')
        }
        const wfPayload = this.buildWorkflowPayload()
        if (wfPayload) {
          try {
            await this.runSubmitWorkflowPlaceholder(wfPayload)
          } catch (wfErr) {
            this.$Message.error('不良品主单已保存，但子流程提交失败，请重试或联系管理员')
            return
          }
        }
        this.$emit('update:editId', null)
        this.$emit('input', false)
        this.$emit('success')
      } catch (e) {
        /* */
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style scoped>
.rma-create-modal-body {
  position: relative;
  min-height: 120px;
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  padding: 0 4px 8px 0;
}
.rma-form-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
  flex-wrap: wrap;
}
.rma-form-meta-l,
.rma-form-meta-r {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rma-lbl {
  color: #333;
  white-space: nowrap;
}
/* 所有带 rma-req 的文案前显示红色必填星标（含 rma-td 表头） */
.rma-req::before {
  content: '*';
  color: #ed4014;
  margin-right: 2px;
}
.rma-inp-meta {
  width: 220px;
}
.rma-form-copy {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  padding: 10px 12px;
  margin-bottom: 12px;
  border: 1px solid #19be6b;
  border-radius: 4px;
  background: #f6fffa;
}
.rma-form-item-inline {
  display: inline-block;
  margin-bottom: 0;
}
.rma-form-block {
  border: 1px solid #e8eaec;
  border-radius: 2px;
  margin-bottom: 10px;
  background: #fff;
}
.rma-form-row2,
.rma-form-row4 {
  display: flex;
  flex-wrap: wrap;
}
.rma-cell {
  border-right: 1px solid #e8eaec;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rma-cell:last-child {
  border-right: none;
}
.rma-cell-half {
  flex: 1;
  min-width: 200px;
}
.rma-cell-quarter {
  flex: 1;
  min-width: 150px;
}
.rma-form-item-block {
  margin-bottom: 0;
}
.rma-form-item-block >>> .ivu-form-item-content {
  margin-left: 0 !important;
}
.rma-radio-yl {
  margin-right: 10px;
}
.rma-form-label-row5,
.rma-form-input-row5 {
  display: flex;
  width: 100%;
}
.rma-td {
  flex: 1;
  min-width: 0;
  border-right: 1px solid #e8eaec;
  padding: 6px 8px;
}
.rma-td:last-child {
  border-right: none;
}
.rma-td.th {
  background: #f8f8f9;
  font-size: 12px;
  text-align: center;
  padding: 8px 4px;
  border-bottom: 1px solid #e8eaec;
}
.rma-td .rma-req {
  display: inline;
}
.rma-nomargin {
  margin-bottom: 0;
}
.rma-nomargin >>> .ivu-form-item-content {
  margin-left: 0 !important;
}
.ivu-form-item {
  margin-bottom: 0px;
}
.ivu-form-item-error {
  margin-bottom: 16px;
}
.rma-fbmain {
  padding: 0 10px 10px;
}
.rma-wf-create {
  padding: 0 10px 10px;
}
.rma-wf-file-hd {
  padding: 6px 10px 0;
  font-size: 12px;
}
.rma-fbmain-hd {
  padding: 10px 0 6px;
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 8px;
}
.rma-sub {
  color: #808695;
  font-size: 12px;
}
.rma-fbmain-desc {
  margin-bottom: 8px;
}
.rma-fbline-extra {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px dashed #e8eaec;
}
.rma-fbline-extra-bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 12px;
  color: #808695;
}
.rma-fbline >>> .ivu-form-item-content {
  margin-left: 0 !important;
}
.rma-uploads {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}
.rma-pic-uploader {
  line-height: 1;
  margin-bottom: 0;
  vertical-align: bottom;
  display: inline-block;
}
.rma-pic-uploader >>> .ivu-upload {
  line-height: 1;
}
.rma-pic-add {
  width: 80px;
  height: 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px 4px;
  border: 1px dashed #b7d4c0;
  border-radius: 4px;
  background: linear-gradient(180deg, #fafffb 0%, #f2faf5 100%);
  color: #515a6e;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;
}
.rma-pic-add:hover {
  border-color: #19be6b;
  background: #f0fff6;
  box-shadow: 0 0 0 1px rgba(25, 190, 107, 0.12);
}
.rma-pic-add:hover .rma-pic-add-ico {
  color: #19be6b;
  transform: scale(1.05);
}
.rma-pic-add-ico {
  color: #8cbe9a;
  transition: color 0.2s ease, transform 0.2s ease;
}
.rma-pic-add-t {
  font-size: 12px;
  font-weight: 500;
  color: #2c8f56;
  letter-spacing: 0.5px;
}
.rma-pic-add-hint {
  font-size: 10px;
  color: #8c8c8c;
  line-height: 1.1;
  text-align: center;
}
.rma-thumb {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: visible;
  flex-shrink: 0;
}
.rma-thumb img {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  vertical-align: top;
}
.rma-thumb-del-hit {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  padding: 4px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  cursor: pointer;
}
.rma-thumb-del-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.52);
  color: #fff;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  transition: background 0.15s ease, transform 0.12s ease;
}
.rma-thumb-del-hit:hover .rma-thumb-del-icon {
  background: rgba(237, 64, 20, 0.95);
  transform: scale(1.06);
}
.rma-thumb-del-hit:active .rma-thumb-del-icon {
  transform: scale(0.96);
}
.rma-fill-meta {
  border: 1px dashed #e8eaec;
  background: #fafafa;
  margin-top: 4px;
}
.rma-fbext-wrap {
  margin: 0 0 8px 0;
}
.margin-top-10 {
  margin-top: 10px;
}
</style>
